import { render } from "./DetailAgencyPage.vue?vue&type=template&id=2a92bd72&scoped=true"
import script from "./DetailAgencyPage.vue?vue&type=script&lang=js"
export * from "./DetailAgencyPage.vue?vue&type=script&lang=js"

import "./DetailAgencyPage.vue?vue&type=style&index=0&id=2a92bd72&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a92bd72"]])

export default __exports__